<div
  class="disclaimer-box"
  [ngClass]="{
    'success': variant === 'success',
    'warning': variant === 'warning',
    'danger': variant === 'danger',
    'secondary': variant === 'secondary'
  }"
  [ngStyle]="{
    'margin': customMargin,
    'padding': customPadding,
    }"
>
  <div class="disclaimer-header">
    <svg-icon
      [src]="iconSrc"
      class="disclaimer-icon"
    ></svg-icon>
    <div class="disclaimer-title">
      {{ titleKey | translate: titleParams }}
    </div>
  </div>
  <div class="disclaimer-description">
    @if (showProgress) {
      <div class="disclaimer-progress">
        <nz-progress
          [nzPercent]="progressValue"
          [nzStatus]="'exception'"
          [nzShowInfo]="false"
        ></nz-progress>
      </div>
    }
    @if (descriptionKey) {
      {{ descriptionKey | translate: descriptionParams }}
    }
    @if (descriptionTemplate) {
      <ng-container *ngTemplateOutlet="descriptionTemplate"></ng-container>
    }
  </div>
  @if (hasActions) {
    <div class="disclaimer-actions">
      <ng-content></ng-content>
    </div>
  }
</div>
